// extracted by mini-css-extract-plugin
export default {"updateButton":"style_updateButton__iegDv","modalContent":"style_modalContent__brfD5"};